export const name = 'pdfDeleteController';
export default function pdfDeleteController($mdDialog, $log, errorDialogOpen, pdfListService) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;

  vm.cancel = cancel;
  vm.deletePdf = deletePdf;
  vm.isInProgress = false;
  vm.isSingle = true;

  init();

  function init(){
      if(vm.pdfsToDelete.length === 1){
          vm.isSingle = true;
      }else{
          vm.isSingle = false;
      }
  }

  function cancel(data) {
    var functionName='pdfDeleteController.cancel';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    $mdDialog.cancel();

    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }

  function deletePdf() {
    var functionName='pdfDeleteController.deletePdf';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    vm.isInProgress = true;

    pdfListService.deleteMany(vm.pdfsToDelete).then(function () {
      $log.info(angular.toJson({action:'pdfs deleted successfully', functionName:functionName}));
      $mdDialog.hide();
    }, function(status) {
      errorDialogOpen.openErrorDialog(status);
      $log.info(angular.toJson({action:'error deleting pdfs', functionName:functionName}));
      $mdDialog.hide();
    });

    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }
}
